import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import { useQuery } from '@tanstack/react-query';
import customerKeys from './keyFactory';

const GetCustomerCustomFields = graphql(`
  query GetCustomerCustomFields($customerId: ID!) {
    customer(id: $customerId) {
      customFields {
        value
        field {
          identifier
          isRequired
          label
          type
          options
          schema
        }
      }
    }
  }
`);

const useGetCustomerCustomFields = (customerId?: string) => {
  const { data, ...rest } = useQuery({
    enabled: !!customerId,
    queryKey: customerKeys.customFields(customerId!),
    queryFn: () => {
      return gqlClient.request(GetCustomerCustomFields, {
        customerId: customerId!,
      });
    },
  });

  return { customFields: data?.customer.customFields, data, ...rest };
};

export default useGetCustomerCustomFields;
